import { render, staticRenderFns } from "./catalogsFilter.vue?vue&type=template&id=3b572586&scoped=true&"
import script from "./catalogsFilter.vue?vue&type=script&lang=js&"
export * from "./catalogsFilter.vue?vue&type=script&lang=js&"
import style0 from "./catalogsFilter.vue?vue&type=style&index=0&id=3b572586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b572586",
  null
  
)

export default component.exports